import QuotationRooms from "app/pages/Booking/Quotation/Accommodation/QuotationRooms";
import PropTypes from "prop-types";
import "./QuotationRoomsBoards.scss";

const QuotationRoomsBoards = ({
	onBoardChange,
	accommodations = [],
	selectedAccommmodationCode,
	stressMarketingLabel,
}) => {
	return (
		<div className="quotation-rooms-boards">
			<div className="quotation-rooms-boards__item">
				<QuotationRooms
					accommodations={accommodations}
					onBoardChange={onBoardChange}
					selectedAccommmodationCode={selectedAccommmodationCode}
					stressMarketingLabel={stressMarketingLabel}
				/>
			</div>
		</div>
	);
};

QuotationRoomsBoards.propTypes = {
	selectedAccommmodationCode: PropTypes.string,
	onBoardChange: PropTypes.func,
	accommodations: PropTypes.any,
	stressMarketingLabel: PropTypes.string,
};

export default QuotationRoomsBoards;
